import React from 'react';
import { ASSET_PREFIX } from 'utils/constants';
import { convertToEmbedLink } from 'utils/video/convertToEmbedLink';

import { InstagramEmbed } from './InstagramEmbed';

interface VideoOverlayProps {
  showVideoOverlay: boolean; // Controls whether the overlay is visible
  onClose: () => void; // Function to toggle the overlay
  videoUrl: string | null; // The YouTube video URL
  videoType: 'instagram' | 'youtube' | null;
}

const VideoOverlay: React.FC<VideoOverlayProps> = ({
  showVideoOverlay,
  onClose,
  videoUrl,
  videoType,
}) => {
  if (!showVideoOverlay || !videoUrl || !videoType) return null; // Don't render anything if the overlay isn't active

  return (
    <div
      onClick={() => onClose()} // Close the overlay on click
      style={{
        zIndex: 1000,
      }}
      className="video-overlay"
    >
      <div className="video-overlay-content">
        <div className={`video-media-wrapper video-media-${videoType}`}>
          {onClose && (
            <img
              className="video-media-close"
              id="closeButton"
              src={`${ASSET_PREFIX}/images/close_button.svg`}
              style={{ cursor: 'pointer', width: '16px' }}
              onClick={onClose}
              alt="close button - cross"
            />
          )}
          {/* YouTube Video Embed */}
          {videoType === 'youtube' && (
            <div className="video-youtube">
              <iframe
                className="video-youtube-iframe"
                frameBorder="0"
                src={convertToEmbedLink(videoUrl)}
                title="YouTube Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          )}
          {/* Instagram Embed */}
          {videoType === 'instagram' && (
            <div className="video-instagram">
              <InstagramEmbed videoLink={videoUrl} />
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        .video-overlay {
          position: fixed;
          inset: 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(0, 0, 0, 0.5);
        }

        .video-overlay-content {
          position: relative;
          display: flex;
          height: 100%;
          width: 100%;
          align-items: center;
          justify-content: center;
        }

        @media (min-width: 768px) {
          .video-overlay-content {
            width: 80%;
          }
        }

        .video-youtube-iframe {
          height: 100%;
          width: 100%;
        }

        .video-media-wrapper {
          position: relative;
          margin: 30px;
          padding: 25px 20px;
          background-color: #fff;
          border-radius: 20px;
          max-width: 95%;
        }

        .video-media-close {
          position: absolute;
          top: 12px;
          right: 14px;
        }

        .video-media-youtube {
          width: 100%;
        }

        .video-youtube {
          margin: 10px 0;
          aspect-ratio: 16 / 9;
          width: 100%;
          overflow: hidden;
          border-radius: 3.5px;
          box-shadow:
            0 10px 15px -3px rgba(0, 0, 0, 0.1),
            0 4px 6px -4px rgba(0, 0, 0, 0.1);
        }

        .video-instagram {
          padding-top: 10px;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 3.5px;
        }

        @media (min-width: 475px) {
          .video-media-wrapper {
            padding: 30px;
          }
          .video-instagram {
            min-width: 406px;
            min-height: 680px;
          }
        }
      `}</style>
    </div>
  );
};

export default VideoOverlay;
